import React, { useEffect, useState } from 'react';
import { useCallAction, useEvent } from '@cobuildlab/react-simple-state';
import { fetchSearchReplies } from './comment-actions';
import { fetchSearchRepliesEvent } from './comment-events';
import {
  Grid,
  TablePagination,
  Container,
  InputBase,
  Paper,
  IconButton,
  Typography,
} from '@mui/material';
import { Loading } from '../../shared/components/Loading';
import SearchIcon from '@mui/icons-material/Search';
import { CommentSearchItem } from './components/CommentSearchItem';
import { ButtonDefault } from '../../shared/components/ButtonDefault';
import { ChangeMultipleCommentStatusDialog } from './components/ChangeMultipleCommentStatusDialog';
import { CommentStatuses, UpdateMultipleType } from './comment-types';

export const SearchReplies: React.FC = () => {
  const { comments, count } = useEvent(fetchSearchRepliesEvent);
  const [callComments, loading] = useCallAction(fetchSearchReplies);
  const [selectedComment, setSelectComment] = useState<number[]>([]);
  const [updateData, setUpdateData] = useState<UpdateMultipleType>();
  const [page, setPage] = useState(0);
  const pageSize = 10;
  const [search, setSearch] = useState('');
  const [openDialog, setOpenDialog] = useState(false);
  //console.log({ comments });
  useEffect(() => {
    return () => {
      callComments(0, 10);
      setSelectComment([]);
    };
  }, [callComments]);

  return (
    <>
      <Container
        maxWidth={'lg'}
        style={{
          borderRadius: '16px',
          background: 'white',
          paddingTop: '16px',
          paddingBottom: '16px',
        }}
      >
        <Grid container xs={12} marginBottom={1} rowSpacing={{ xs: 1, sm: 2 }}>
          <Grid item xs={12}>
            <Paper
              sx={{
                p: '2px 4px',
                display: 'flex',
                alignItems: 'center',
                width: '100%',
              }}
            >
              <InputBase
                sx={{ ml: 1, flex: 1 }}
                placeholder={'BUSCAR RESPUESTAS'}
                inputProps={{
                  'aria-label': 'search',
                  style: {
                    fontWeight: 700,
                    color: 'black',
                  },
                }}
                slotProps={{}}
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
                value={search}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    callComments(0, pageSize, search);
                    setPage(0);
                    setSelectComment([]);
                  }
                }}
              />
              <IconButton
                type="button"
                onClick={() => {
                  callComments(0, pageSize, search);
                  setSelectComment([]);
                  setPage(0);
                }}
                sx={{ p: '10px' }}
                aria-label="search"
              >
                <SearchIcon />
              </IconButton>
            </Paper>
          </Grid>
          {comments?.length ? (
            <Grid
              item
              xs={12}
              display={'flex'}
              flexDirection={{ xs: 'column', sm: 'row' }}
              alignItems={{ xs: 'start', sm: 'start' }}
            >
              <ButtonDefault
                onClick={() => {
                  setUpdateData({
                    status: CommentStatuses.APPROVED,
                    comments: undefined,
                    search,
                    message:
                      '¿Estas seguro que deseas aprobar ' +
                      count +
                      ' comentarios con la palabra ' +
                      search +
                      '?',
                  });
                  setOpenDialog(true);
                }}
                //isLoading={loadingReport}
                sx={{
                  width: 190,
                  height: 40,
                  textTransform: 'inherit',
                  marginRight: { xs: '0px', sm: '8px' },
                  marginBottom: { xs: '8px', sm: '0px' },
                  fontWeight: 700,
                  background: '#2e7d32',
                }}
              >
                Aprobar Busqueda
              </ButtonDefault>
              <ButtonDefault
                onClick={() => {
                  setUpdateData({
                    status: CommentStatuses.REJECTED,
                    comments: undefined,
                    search,
                    message:
                      '¿Estas seguro que deseas rechazar ' +
                      count +
                      ' comentarios con la palabra ' +
                      search +
                      '?',
                  });
                  setOpenDialog(true);
                }}
                //isLoading={loadingReport}
                sx={{
                  width: 190,
                  height: 40,
                  textTransform: 'inherit',
                  fontWeight: 700,
                  background: '#FF0000',
                }}
              >
                Rechazar Busqueda
              </ButtonDefault>
            </Grid>
          ) : null}
        </Grid>

        <Grid
          container
          paddingY={!selectedComment?.length ? 0 : 1}
          paddingX={!selectedComment?.length ? 0 : 1}
          xs={12}
          border={!selectedComment?.length ? 'none' : '1px solid black'}
          borderRadius={'4px'}
        >
          {selectedComment?.length ? (
            <Grid
              paddingBottom={1}
              item
              xs={12}
              display={'flex'}
              justifyContent={'center'}
            >
              <Typography>
                ({selectedComment?.length}) Seleccionado/s
              </Typography>
            </Grid>
          ) : null}
          {selectedComment?.length ? (
            <Grid
              item
              xs={12}
              display={'flex'}
              flexDirection={{ xs: 'column', sm: 'row' }}
              alignItems={{ xs: 'end', sm: 'start' }}
              paddingBottom={2}
              justifyContent={'end'}
            >
              <ButtonDefault
                onClick={() => {
                  setUpdateData({
                    status: CommentStatuses.APPROVED,
                    comments: selectedComment,
                    search: undefined,
                    message:
                      '¿Estas seguro que deseas aprobar ' +
                      selectedComment?.length +
                      ' comentarios?',
                  });
                  setOpenDialog(true);
                }}
                //isLoading={loadingReport}
                sx={{
                  width: 190,
                  height: 40,
                  textTransform: 'inherit',
                  marginRight: { xs: '0px', sm: '8px' },
                  marginBottom: { xs: '8px', sm: '0px' },
                  fontWeight: 700,
                  background: '#2e7d32',
                }}
              >
                Aprobar Selección
              </ButtonDefault>
              <ButtonDefault
                onClick={() => {
                  setUpdateData({
                    status: CommentStatuses.REJECTED,
                    comments: selectedComment,
                    search: undefined,
                    message:
                      '¿Estas seguro que deseas rechazar ' +
                      selectedComment?.length +
                      ' comentarios?',
                  });
                  setOpenDialog(true);
                }}
                //isLoading={loadingReport}
                sx={{
                  width: 190,
                  height: 40,
                  textTransform: 'inherit',
                  fontWeight: 700,
                  background: '#FF0000',
                }}
              >
                Rechazar Selección
              </ButtonDefault>
            </Grid>
          ) : null}
          {loading ? (
            <Grid item xs={12}>
              <Loading height="300px">Cargando...</Loading>
            </Grid>
          ) : (
            comments.map((item, i) => (
              <Grid key={i} item xs={12} paddingBottom={2}>
                <CommentSearchItem
                  search={search}
                  selected={selectedComment.includes(item.id)}
                  onSelectOrUnselect={() => {
                    if (selectedComment.includes(item.id)) {
                      setSelectComment((prev) =>
                        prev.filter((it) => it != item.id),
                      );
                    } else {
                      setSelectComment((prev) => [...prev, item.id]);
                    }
                  }}
                  comment={item}
                  onRefetch={() => {
                    callComments(page, pageSize, search);
                  }}
                />
              </Grid>
            ))
          )}
          <Grid xs={12}>
            <TablePagination
              count={count}
              component="div"
              page={page}
              rowsPerPage={pageSize}
              onPageChange={(event: unknown, newPage: number) => {
                setPage(newPage);
                callComments(newPage, pageSize, search);
                console.log(newPage, pageSize, search);
              }}
              rowsPerPageOptions={[]}
            />
          </Grid>
        </Grid>
      </Container>
      <ChangeMultipleCommentStatusDialog
        onHandleClose={() => setOpenDialog(false)}
        open={openDialog}
        isReplies={true}
        comments={updateData?.comments}
        status={updateData?.status}
        search={updateData?.search}
        warningMessage={updateData?.message}
        onSuccess={() => {
          callComments(page, pageSize, search);
        }}
      />
    </>
  );
};
